import * as React from 'react';
import { forwardRef } from 'react';
import { useLogout } from 'react-admin';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import ExitIcon from '@mui/icons-material/PowerSettingsNew';


const MyLogoutButton = forwardRef((props, ref) => {
    const logout = useLogout();
    const handleClick = () => {
        localStorage.removeItem("__state");
        // Clear local storage
        localStorage.clear();

        // Clear session storage
        sessionStorage.clear();
        logout();
    };
    return (
        <MenuItem
            onClick={handleClick}
            ref={ref}
        >
            <ExitIcon /> Logout
        </MenuItem>
    );
});

export default MyLogoutButton;